// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3ZY05","containerItemsCenter":"Skeleton_containerItemsCenter__32WPe"};